import { z } from 'zod';

export const checkVideosRequestSchema = z.object({
  paths: z.array(z.string()),
});

export type ICheckVideosRequest = z.infer<typeof checkVideosRequestSchema>;
